// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__pnGPm","title":"ClientInsurance_title__2ET6I","itemText":"ClientInsurance_itemText__2ET6i"};